export default __webpack_public_path__ + "src/images/btn_graduate-0f7c25.png";